// ─── PRICING ENGINE ───────────────────────────────────────────────────────────
//
// Extracted from configurator.html's inline script (Phase 5 split). Loaded via
// <script src> at the exact document position this code used to occupy inline
// -- must stay before configurator.html's INIT section, which depends on it.
//
// Depends on globals declared earlier in configurator.html's own script:
// CATEGORIES, currentCat, currentPackageSize, getSelectedSizeLabel().

// ─── PRICING (must be before INIT) ───────────────────────────────────────────

var PRICING_DEFAULTS = {
  minQty: 20,
  markup: 0,
  // Base = white vinyl 2"×2"
  // Size & material multipliers applied on top
  tiers: [
    { qty: 10,    unitPrice: 1.7000 },
    { qty: 20,    unitPrice: 1.5000 },
    { qty: 50,    unitPrice: 1.2000 },
    { qty: 100,   unitPrice: 0.7300 },
    { qty: 200,   unitPrice: 0.4750 },
    { qty: 300,   unitPrice: 0.3833 },
    { qty: 500,   unitPrice: 0.3040 },
    { qty: 1000,  unitPrice: 0.2320 },
    { qty: 2000,  unitPrice: 0.1855 },
    { qty: 3000,  unitPrice: 0.1653 },
    { qty: 5000,  unitPrice: 0.1446 },
    { qty: 10000, unitPrice: 0.1225 },
  ],
  // Multipliers based on 50-qty SM prices — note: actual mult grows with qty
  // Ten squares, one per quantity break from 50 through 10,000, plus Custom.
  // 2–5" keep the calibrated multipliers. 1" and 6–10" use (w×h/4)^0.30.
  sizes: [
    { label: '1" \xd7 1"', w: 1, h: 1, mult: 0.660 },
    { label: '2" \xd7 2"', w: 2, h: 2, mult: 1.000 },
    { label: '3" \xd7 3"', w: 3, h: 3, mult: 1.200 },
    { label: '4" \xd7 4"', w: 4, h: 4, mult: 1.450 },
    { label: '5" \xd7 5"', w: 5, h: 5, mult: 1.733 },
    { label: '6" \xd7 6"', w: 6, h: 6, mult: 1.933 },
    { label: '7" \xd7 7"', w: 7, h: 7, mult: 2.121 },
    { label: '8" \xd7 8"', w: 8, h: 8, mult: 2.297 },
    { label: '9" \xd7 9"', w: 9, h: 9, mult: 2.466 },
    { label: '10" \xd7 10"', w: 10, h: 10, mult: 2.627 },
    { label: 'Custom',     w: null, h: null, mult: 1.000 },
  ],
  // Material multipliers vs white vinyl (calibrated from market pricing data)
  // Clear:   1.03× (50qty) → 1.10× (10kqty), avg ~1.07×
  // Glitter: 1.08× (50qty) → 1.38× (10kqty), avg ~1.13× in 50–1k range
  // Holo:    avg 1.18×, using conservative 1.15×
  materials: [
    { id: 'white-vinyl', label: 'White Vinyl',  mult: 1.000 },
    { id: 'clear',       label: 'Clear',        mult: 1.070 },
    { id: 'holo',        label: 'Holo',         mult: 1.150 },
    { id: 'reflective',  label: 'Reflective',   mult: 1.200 },
    { id: 'chrome',      label: 'Chrome',       mult: 1.200 },
    { id: 'gold',        label: 'Gold',         mult: 1.200 },
    { id: 'glitter',     label: 'Glitter',      mult: 1.130 },
  ],
  // satin -> Satin; glitter -> Galactic Series metal flake (glitter-lam-*);
  // holo -> Spectrum holographic (holo-lam-*). Percent upcharges.
  laminateUpcharges: { satin: 3, glitter: 8, holo: 8 },
  // Percentage upcharge for finish selection (glossy is the reference, 0%).
  // Leave a field unset/0 in admin to charge no upcharge for that finish.
  finishUpcharges: { matte: 8 }
};

function loadPricing() {
  try {
    var stored = localStorage.getItem('vinylpac_pricing');
    if (!stored) return PRICING_DEFAULTS;
    var parsed = JSON.parse(stored);
    // Older saves only had 2–5". Swap that exact list for the current squares
    // in memory. Leave a custom admin list alone, and do not write storage.
    var legacy = ['2" \xd7 2"', '3" \xd7 3"', '4" \xd7 4"', '5" \xd7 5"', 'Custom'];
    var sizes = parsed.sizes || [];
    var isLegacy = sizes.length === legacy.length && legacy.every(function(label, i) {
      return sizes[i] && sizes[i].label === label;
    });
    if (isLegacy) parsed.sizes = PRICING_DEFAULTS.sizes.map(function(s) { return Object.assign({}, s); });
    return parsed;
  } catch(e) { return PRICING_DEFAULTS; }
}

// ── Admin-configurable upcharge multipliers ───────────────────────────────────
// Single source of truth for material/finish/laminate multipliers, applied on
// top of a product's base price (whether that base comes from the v2
// per-product-type tables above, or the legacy qty-tier × sizeMult formula).
// Every value here is read from admin-configured `pricing` -- nothing is
// hardcoded, and any upcharge left unset in admin defaults to 1.0 (no charge).
// Depends on getMatMult() (sq-panel.js, loaded before this file) and the
// currentFinish/currentSpecialty globals (product-state.js).
function vpGetMultipliers(pricing) {
  var matMult = getMatMult(pricing);

  var fin = pricing.finishUpcharges || {};
  var finishMult = (currentFinish === 'matte') ? 1 + (fin.matte || 0) / 100 : 1.0;

  var lam = pricing.laminateUpcharges || {};
  var spotMult = currentSpecialty === 'none' ? 1.0
               : currentSpecialty === 'satin' ? 1 + (lam.satin || 0) / 100
               : currentSpecialty.indexOf('glitter-lam-') === 0 ? 1 + (lam.glitter || 0) / 100
               : currentSpecialty.indexOf('holo-lam-') === 0 ? 1 + (lam.holo || 0) / 100
               : 1.0; // unrecognised specialty value -- no upcharge

  return { matMult: matMult, finishMult: finishMult, spotMult: spotMult };
}

// ─── PRODUCT PRICING ENGINE v2 ────────────────────────────────────────────────
// Replaces the generic tiers×sizeMult×matMult formula for product-specific pricing.
// Key: eff = sqrt(W × H)  (effective diameter — same for equal-area shapes)
// Small format (eff ≤ 9): per-product lookup tables with bilinear interpolation.
// Large format (eff > 9): unified 2D table + $0.10/sticker markup + qty discounts.
// Die Cut keeps the legacy formula; Kiss Cut Transfer uses the H+W formula.
// ─────────────────────────────────────────────────────────────────────────────

// Qty-scale curves: total_at_qty = q50_price × scale[qty]
// Derived by averaging ratio curves from fully-calibrated anchor rows.
// Used to fill qty tiers for size anchors that have only qty=50 data.
var VP_QTY_SCALES = {
  standard: { 50:1.000, 100:1.686, 200:3.003, 300:4.308, 500:7.027,
              1000:13.93, 2000:27.72, 3000:41.50, 5000:69.05, 10000:137.9 },
  'kiss-cut': { 10:0.276, 50:1.000, 100:1.560, 200:2.545, 300:3.437, 500:5.076,
               1000:8.736, 2000:15.18, 5000:35.10, 10000:69.62 },
  clear:    { 50:1.000, 100:1.574, 200:2.587, 300:3.501, 500:5.188,
              1000:8.950, 2000:15.58, 3000:22.02, 5000:36.26, 10000:72.00 },
  cling:    { 50:1.000, 100:1.484, 200:2.326, 300:3.090, 500:4.498,
              1000:7.624, 2000:13.13, 3000:18.12, 5000:27.45, 10000:53.27 }
};
VP_QTY_SCALES.sheets = VP_QTY_SCALES.standard;

// Small-format lookup tables.  Each row: { eff, tiers: { qty: totalPrice } }
// Only qty=50 is required; other tiers filled by scale curve when absent.
var VP_TABLES = {
  // Circle, Square, Rectangle, Oval — calibrated from market circle/square data
  standard: [
    { eff:1, tiers:{ 50:51  } },
    { eff:2, tiers:{ 50:58  } },
    { eff:3, tiers:{ 50:68  } },
    { eff:4, tiers:{ 50:79  } },
    { eff:5, tiers:{ 50:93  } },
    { eff:7, tiers:{ 50:126 } },
    { eff:8, tiers:{ 50:145 } }
    // eff=9 interpolated toward large-format table at eff=10
  ],
  // Kiss Cut (non-transfer) — sqrt ≤ 9 for small format; extends beyond via VP_LARGE
  'kiss-cut': [
    { eff:2,      tiers:{ 10:17,  50:60  } },
    { eff:3,      tiers:{ 10:20,  50:72  } },
    { eff:4,      tiers:{ 10:24,  50:87  } },
    { eff:5,      tiers:{ 10:29,  50:105 } },
    { eff:7,      tiers:{ 10:41,  50:147, 100:227,  200:368,  300:496,
                           500:730,  1000:1253, 2000:2173, 5000:4896,  10000:9702  } },
    { eff:8,      tiers:{ 10:47,  50:172, 100:271,  200:445,  300:602,
                           500:892,  1000:1539, 2000:2678, 5000:6344,  10000:12597 } },
    { eff:12.247, tiers:{ 50:298 } },
    { eff:15,     tiers:{ 10:107, 50:397, 100:668,  200:1146, 300:1580,
                           500:2379, 1000:4426, 2000:8794, 5000:21880, 10000:43670 } },
    { eff:17.321, tiers:{ 50:490 } },
    { eff:29.394, tiers:{ 10:295, 50:1102 } }
  ],
  // Clear Stickers
  clear: [
    { eff:2,      tiers:{ 50:62  } },
    { eff:3,      tiers:{ 50:75  } },
    { eff:4,      tiers:{ 50:92  } },
    { eff:5,      tiers:{ 50:112 } },
    { eff:7,      tiers:{ 50:159, 100:248,  200:405,  300:547,  500:808,
                           1000:1391, 2000:2417, 3000:3349, 5000:5484,  10000:10878 } },
    { eff:8,      tiers:{ 50:187, 100:297,  200:491,  300:666,  500:990,
                           1000:1711, 2000:2982, 3000:4297, 5000:7111,  10000:14133 } },
    { eff:12.247, tiers:{ 50:328 } },
    { eff:15,     tiers:{ 50:438, 100:741,  200:1275, 300:1760, 500:2652,
                           1000:4966, 2000:9874, 3000:14778, 5000:24580, 10000:49070 } },
    { eff:18.439, tiers:{ 50:596 } },
    { eff:29.394, tiers:{ 50:1226 } }
  ],
  // Static Cling
  cling: [
    { eff:2,      tiers:{ 50:55  } },
    { eff:3,      tiers:{ 50:62  } },
    { eff:4,      tiers:{ 50:72  } },
    { eff:5,      tiers:{ 50:82  } },
    { eff:7,      tiers:{ 50:108, 100:158,  200:246,  300:325,  500:471,
                           1000:795,  2000:1366, 3000:1883, 5000:2832,  10000:5390  } },
    { eff:8,      tiers:{ 50:123, 100:185,  200:292,  300:390,  500:570,
                           1000:970,  2000:1673, 3000:2312, 5000:3528,  10000:6965  } },
    { eff:15,     tiers:{ 50:260, 100:427,  200:720,  300:986,  500:1475,
                           1000:2568, 2000:4834, 3000:7218, 5000:11980, 10000:23870 } },
    { eff:15.811, tiers:{ 50:279 } },
    { eff:18.974, tiers:{ 50:360 } },
    { eff:25,     tiers:{ 50:540 } }
  ],
  // Sticker Sheets — priced per sheet
  sheets: [
    { eff:4.899,  tiers:{ 50:119  } },  // 4×6
    { eff:5.916,  tiers:{ 50:145  } },  // 5×7
    { eff:8.944,  tiers:{ 50:239  } },  // 8×10
    { eff:9.670,  tiers:{ 50:265  } },  // 8.5×11
    { eff:13.674, tiers:{ 50:432  } },  // 11×17
    { eff:18.894, tiers:{ 50:701  } },  // 21×17
    { eff:29.394, tiers:{ 50:1396 } }   // 36×24
  ]
};

// Large-format table (eff > 9 for standard-type sticker products).
// +$0.10/sticker markup over reference.  Volume discounts: 4%@100, 8%@200, 15%@500.
var VP_LARGE = {
  markup: 0.10,
  discounts: [{ qty:100, pct:0.04 }, { qty:200, pct:0.08 }, { qty:500, pct:0.15 }],
  table: [
    { eff:10,     tiers:{ 1:26,  10:96,  50:338, 100:635,  200:1227, 300:1817,
                           500:2997,  1000:5942,  2000:11823, 5000:29437 } },
    { eff:10.954, tiers:{ 1:28,  10:107, 50:397, 100:751,  200:1459, 300:2166,
                           500:3579,  1000:7106,  2000:14151, 5000:35257 } },
    { eff:11,     tiers:{ 1:28,  10:107, 50:400, 100:757,  200:1471, 300:2184,
                           500:3608,  1000:7164,  2000:14267, 5000:35548 } },
    { eff:11.832, tiers:{ 1:30,  10:117, 50:455, 100:868,  200:1692, 300:2516,
                           500:4161,  1000:8270,  2000:16479, 5000:41077 } },
    { eff:12,     tiers:{ 1:30,  10:119, 50:467, 100:891,  200:1739, 300:2586,
                           500:4278,  1000:8503,  2000:16944, 5000:42241 } },
    { eff:12.247, tiers:{ 1:30,  10:122, 50:484, 100:926,  200:1809, 300:2690,
                           500:4452,  1000:8852,  2000:17643, 5000:43987 } },
    { eff:15,     tiers:{ 1:36,  10:160, 50:702, 100:1362, 200:2682, 300:4000,
                           500:6635,  1000:13217, 2000:26373, 5000:65812 } }
  ]
};

var VP_LARGE_THRESHOLD = 9; // eff > this → large-format pricing

// ── Core helpers ──────────────────────────────────────────────────────────────

// Linear interpolation across a { qty: totalPrice } object.
// Extrapolates proportionally beyond the table bounds.
function vpInterpTiers(tiers, qty) {
  var qs = Object.keys(tiers).map(Number).sort(function(a, b) { return a - b; });
  if (!qs.length) return 0;
  if (qty <= qs[0]) return tiers[qs[0]] * qty / qs[0];
  var last = qs[qs.length - 1];
  if (qty >= last) return tiers[last] * qty / last;
  for (var i = 0; i < qs.length - 1; i++) {
    if (qty >= qs[i] && qty <= qs[i + 1]) {
      var t = (qty - qs[i]) / (qs[i + 1] - qs[i]);
      return tiers[qs[i]] + t * (tiers[qs[i + 1]] - tiers[qs[i]]);
    }
  }
  return tiers[qs[0]];
}

// Price for a single small-format table row at a given qty.
// Uses real tier data where stored; scale curve fills remaining qtys.
function vpRowPrice(row, qty, scaleKey) {
  var tiers  = row.tiers;
  var scales = VP_QTY_SCALES[scaleKey] || VP_QTY_SCALES.standard;
  var qs     = Object.keys(tiers).map(Number).sort(function(a, b) { return a - b; });
  // In-range of stored data → interpolate directly
  if (qs.length > 1 && qty >= qs[0] && qty <= qs[qs.length - 1]) {
    return vpInterpTiers(tiers, qty);
  }
  // Below minimum stored qty → scale down
  if (qty < qs[0]) return tiers[qs[0]] * qty / qs[0];
  // Above stored data → scale from q50 via scale curve
  var q50 = tiers[50] !== undefined ? tiers[50]
          : tiers[qs[0]] / (scales[qs[0]] || 1);
  return q50 * vpInterpTiers(scales, qty);
}

// Bilinear interpolation across a small-format table for (eff, qty).
function vpSmallLookup(tableKey, eff, qty) {
  var rows = VP_TABLES[tableKey];
  if (!rows || !rows.length) return null;
  var lo = rows[0], hi = rows[rows.length - 1];
  for (var i = 0; i < rows.length; i++) {
    if (rows[i].eff <= eff) lo = rows[i];
    else { hi = rows[i]; break; }
  }
  var pLo = vpRowPrice(lo, qty, tableKey);
  if (lo === hi) return pLo;
  var pHi = vpRowPrice(hi, qty, tableKey);
  var t   = (eff - lo.eff) / (hi.eff - lo.eff);
  return pLo + t * (pHi - pLo);
}

// Bilinear lookup in the large-format table; applies markup + discounts.
function vpLargeLookup(eff, qty) {
  var rows = VP_LARGE.table;
  var lo = rows[0], hi = rows[rows.length - 1];
  for (var i = 0; i < rows.length; i++) {
    if (rows[i].eff <= eff) lo = rows[i];
    else { hi = rows[i]; break; }
  }
  var pLo   = vpInterpTiers(lo.tiers, qty);
  var pHi   = (lo === hi) ? pLo : vpInterpTiers(hi.tiers, qty);
  var base  = (lo === hi) ? pLo : pLo + ((eff - lo.eff) / (hi.eff - lo.eff)) * (pHi - pLo);
  base += VP_LARGE.markup * qty;
  var disc  = 0;
  VP_LARGE.discounts.forEach(function(d) { if (qty >= d.qty) disc = d.pct; });
  return base * (1 - disc);
}

// Kiss Cut Transfer: flat per-unit price from H+W sum × qty.
// +$0.10/sticker over the base reference rates.
function vpKcTransferTotal(w, h, qty) {
  var sum  = w + h;
  var unit = sum <= 5 ? 1.40 : sum <= 8 ? 1.50 : 0.70 + sum * 0.10;
  return unit * qty;
}

// ── Product type detection ────────────────────────────────────────────────────

function vpGetProductType() {
  // Labels reuses sticker shape names (Circle Sheet, Square Sheet, etc.), which
  // would otherwise match the keyword checks below and get routed into the
  // sticker-specific VP_TABLES -- a pricing model with no material axis. Labels
  // always uses the legacy formula instead, which does apply material multiplier.
  if (currentCat === 'labels') return null;
  var cat  = CATEGORIES[currentCat];
  var name = (cat && (cat._customName || cat.name) || '').toLowerCase();
  if (name.indexOf('die cut')  !== -1 || name.indexOf('die-cut') !== -1) return 'die-cut';
  if (name.indexOf('transfer') !== -1)                                    return 'kc-transfer';
  if (name.indexOf('kiss')     !== -1)                                    return 'kiss-cut';
  if (name.indexOf('circle')   !== -1 || name.indexOf('square')     !== -1 ||
      name.indexOf('rectangle')!== -1 || name.indexOf('oval')       !== -1) return 'standard';
  if (name.indexOf('clear')    !== -1)                                    return 'clear';
  if (name.indexOf('cling')    !== -1)                                    return 'cling';
  if (name.indexOf('sheet')    !== -1)                                    return 'sheets';
  return null; // fall back to legacy Die Cut formula
}

// Read current width/height from the size selector or custom inputs.
function vpGetCurrentDims() {
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  if (printKind === 'yard-signs') return { w: 18, h: 24 };
  if (currentPackageSize) {
    return { w: currentPackageSize.sideW || 2, h: currentPackageSize.sideH || 2 };
  }
  var label = getSelectedSizeLabel();
  if (!label) {
    if (printKind === 'banners') return { w: 24, h: 36 };
    if (printKind === 'posters') return { w: 18, h: 24 };
    return { w: 2, h: 2 };
  }
  if (label === 'Custom') {
    var fallbackW = printKind === 'banners' ? 24 : printKind ? 18 : 2;
    var fallbackH = printKind === 'banners' ? 36 : printKind ? 24 : 2;
    return {
      w: parseFloat(document.getElementById('customW').value) || fallbackW,
      h: parseFloat(document.getElementById('customH').value) || fallbackH
    };
  }
  if (printKind && typeof vpPrintSizes === 'function') {
    var printSizes = vpPrintSizes(printKind);
    for (var pi = 0; pi < printSizes.length; pi++) {
      if (printSizes[pi].label === label && printSizes[pi].w && printSizes[pi].h) {
        return { w: printSizes[pi].w, h: printSizes[pi].h };
      }
    }
  }
  var pricing = loadPricing();
  for (var i = 0; i < pricing.sizes.length; i++) {
    var sz = pricing.sizes[i];
    if (sz.label === label && sz.w && sz.h) return { w: sz.w, h: sz.h };
  }
  // Parse dims from label text e.g. "4" × 6""
  var m = label.match(/([\d.]+)/g);
  if (m && m.length >= 2) return { w: parseFloat(m[0]), h: parseFloat(m[1]) };
  return { w: 2, h: 2 };
}

// ── Command quote spec ────────────────────────────────────────────────────────
// Products the Command quote tool already prices: POST /api/quote (no Sue
// material/finish/laminate multipliers on top — that would double-charge).
// Display (updatePrice) and charge (addToCart) share the result via
// window._vpLastQuote keyed by vpQuoteKey(spec). Everything else stays on
// vpComputeTotal / legacy + vpGetMultipliers.

function vpQuoteKey(spec) {
  if (!spec) return '';
  return [spec.w, spec.h, spec.qty, spec.cut, spec.finish, spec.emboss].join('|') + (spec.laminate ? '|' + spec.laminate : '');
}

function vpQuoteProductName() {
  if (typeof CATEGORIES === 'undefined' || !CATEGORIES[currentCat]) return '';
  return String(CATEGORIES[currentCat]._customName || CATEGORIES[currentCat].name || '').toLowerCase();
}

function vpQuoteChipId() {
  return String(typeof currentChipId !== 'undefined' && currentChipId ? currentChipId : '').toLowerCase();
}

function vpQuoteKeepSue() {
  if (typeof CATEGORIES === 'undefined') return true;
  if (currentCat === 'packaging' || currentCat === 'posters') return true;
  var name = vpQuoteProductName();
  var chip = vpQuoteChipId();
  if (name.indexOf('flower jar') !== -1 || name.indexOf('miron jar') !== -1) return true;
  if (name.indexOf('mylar') !== -1) return true;
  if (name.indexOf('pre-roll') !== -1 || name.indexOf('preroll') !== -1 || name.indexOf('pre roll') !== -1) return true;
  if (name.indexOf('poster') !== -1 || name.indexOf('banner') !== -1 || name.indexOf('yard sign') !== -1) return true;
  // Josh 10/17: Embossed Clear + Embossed Perforated really emboss, priced like the other embossed die cuts (Command quote).
  if (chip === 'emb-clear' || chip === 'emb-perf') return false;
  if (vpPricedAsCut()) return false;
  if (name.indexOf('perforat') !== -1) return true;
  return false;
}

// Josh 10/31 (pricing audit): "Same as die cut but vinyl lettering is kisscut with transfer tape". Clear, Static
// Cling and Front Adhesive price from the book as die-cut, Vinyl Lettering as kiss + tape (they were Sue's formula).
// Only the price moves: their options stay as Josh set them, no embossing and no die-cut-only laminates (10/17, 10/18).
function vpPricedAsCut() {
  var name = vpQuoteProductName();
  var chip = vpQuoteChipId();
  if (chip === 'emb-clear' || chip === 'emb-perf') return null;
  if (name.indexOf('vinyl letter') !== -1 || chip === 'vinyl-letter') return 'tape';
  if (name.indexOf('front adhes') !== -1 || chip === 'front-adhes') return 'die';
  if (name.indexOf('cling') !== -1 || chip === 'static-cling') return 'die';
  if (name.indexOf('clear') !== -1 || chip === 'clear') return 'die';
  return null;
}

function vpQuoteCut() {
  if (vpQuoteKeepSue()) return null;
  var pricedAs = vpPricedAsCut();
  if (pricedAs) return pricedAs;
  var name = vpQuoteProductName();
  var chip = vpQuoteChipId();
  var CHIP_CUT = {
    'die-cut': 'die',
    'circle': 'die',
    'square': 'die',
    'rectangle': 'die',
    'kiss-cut': 'kiss',
    'transfer': 'tape',
    'sheets': 'sheet',
    'lbl-circle': 'sheet',
    'lbl-die-cut': 'sheet',
    'lbl-oval': 'sheet',
    'lbl-rect': 'sheet',
    'lbl-rounded': 'sheet',
    'lbl-square': 'sheet',
    'lbl-roll': 'roll',
    'emb-die-cut': 'die',
    'emb-circle': 'die',
    'emb-square': 'die',
    'emb-rect': 'die',
    'emb-holo': 'die',
    'emb-sheets': 'sheet',
    'emb-kiss': 'kiss',
    'emb-perf': 'die',
    'emb-clear': 'die'
  };
  var cut = CHIP_CUT[chip] || null;
  var isEmbossed = currentCat === 'embossed-stickers' || name.indexOf('emboss') !== -1 || chip.indexOf('emb-') === 0;
  if (!cut) {
    if (name.indexOf('transfer') !== -1) cut = 'tape';
    else if (name.indexOf('roll') !== -1) cut = 'roll';
    else if (name.indexOf('sheet') !== -1) cut = 'sheet';
    else if (name.indexOf('kiss') !== -1) cut = 'kiss';
    else if (name.indexOf('die cut') !== -1 || name.indexOf('die-cut') !== -1 || name.indexOf('diecut') !== -1) cut = 'die';
    else if (name.indexOf('circle') !== -1 || name.indexOf('square') !== -1 || name.indexOf('rectangle') !== -1) cut = 'die';
    else if (isEmbossed && (name.indexOf('holo') !== -1 || name.indexOf('holographic') !== -1)) cut = 'die';
    else if (currentCat === 'labels') cut = 'sheet';
    else if (currentCat === 'custom-stickers' || currentCat === 'embossed-stickers' || currentCat === 'specialty-stickers') cut = 'die';
  }
  return cut;
}

function vpCutAllowsEmboss(cut) {
  if (vpPricedAsCut()) return false;
  cut = cut || vpQuoteCut();
  return cut === 'die' || cut === 'sheet' || cut === 'kiss';
}

var VP_QUOTE_LAM = {
  'glitter-lam-silver': 'silver-glitter', 'glitter-lam-gold': 'gold-glitter', 'glitter-lam-stardust': 'stardust',
  'glitter-lam-rainbow': 'rainbow-glitter', 'glitter-lam-red': 'silver-glitter',
  'glitter-lam-neptune': 'silver-glitter',
  'holo-lam-fracture': 'fracture', 'holo-lam-prismatic': 'prismatic',
  'holo-lam-cosmic': 'super-cosmic', 'holo-lam-hex': 'hex',
  'holo-lam-hearts': 'heart-holo'
};
// A specialty laminate chip → the quote API's laminate key ('' for none / satin / unknown).
function vpQuoteLamKey(spot) {
  if (typeof spot !== 'string') return '';
  if (VP_QUOTE_LAM[spot]) return VP_QUOTE_LAM[spot];
  if (spot.indexOf('glitter-lam-') === 0) return 'glitter';
  return '';
}

// Josh 10/31 ("Charge the laminate add"): on a vinyl that vpQuoteFinish() sends as itself (holo, glitter, chrome,
// gold, reflective), a picked laminate goes beside it and the quote adds its flat price. '' = nothing to add.
var VP_QUOTE_VINYLS = ['holo', 'glitter', 'chrome', 'mirror', 'gold', 'reflective'];
function vpQuoteLaminate() {
  var mat = (typeof MATERIALS !== 'undefined' && MATERIALS[currentMat]) ? MATERIALS[currentMat] : null;
  var matId = mat && mat.id ? String(mat.id).toLowerCase() : '';
  if (VP_QUOTE_VINYLS.indexOf(matId) === -1) return '';
  return vpQuoteLamKey(typeof currentSpecialty === 'string' ? currentSpecialty : 'none');
}

function vpQuoteFinish() {
  var name = vpQuoteProductName();
  var mat = (typeof MATERIALS !== 'undefined' && MATERIALS[currentMat]) ? MATERIALS[currentMat] : null;
  var matId = mat && mat.id ? String(mat.id).toLowerCase() : '';
  if (matId === 'holo') return 'holo';
  if (matId === 'glitter') return 'glitter';
  if (matId === 'chrome' || matId === 'mirror') return 'chrome';
  if (matId === 'gold') return 'gold';
  if (matId === 'reflective') return 'reflective';
  // Overlaminates go to the quote API as Command's own laminate keys
  // (addons.json laminate_surcharge: Galactic flakes +$0.40, Spectrum films
  // +$0.60, never blended into the vinyl cell). 'holo' would have priced a
  // Spectrum film off the holographic VINYL chart, which is a different thing.
  // Mars Red / Neptune have no key in addons.json yet, so they ride the
  // Galactic silver-glitter surcharge until Josh adds them there.
  var lamKey = vpQuoteLamKey(currentSpecialty);
  if (lamKey) return lamKey;
  if (currentFinish === 'matte') return 'matte';
  if (name.indexOf('gold') !== -1) return 'gold';
  if (name.indexOf('reflective') !== -1) return 'reflective';
  if (name.indexOf('holographic') !== -1 || name.indexOf('holo') !== -1) return 'holo';
  if (name.indexOf('glitter') !== -1) return 'glitter';
  if (name.indexOf('chrome') !== -1 || name.indexOf('mirror') !== -1) return 'chrome';
  return 'gloss';
}

function vpNormEmboss(id) {
  var raw = String(id == null ? 'none' : id).toLowerCase();
  if (raw === 'true' || raw === 'emboss' || raw === 'std' || raw === 'hd' || raw === 'standard' || raw === '2') return 'std';
  if (raw === 'light' || raw === 'spot' || raw === '1') return 'std';
  if (raw === 'heavy' || raw === '3d' || raw === 'super-hd' || raw === '3' || raw === '4') return 'heavy';
  return 'none';
}

function vpQuoteEmboss(cut) {
  cut = cut || vpQuoteCut();
  if (!vpCutAllowsEmboss(cut)) return 'none';
  return vpNormEmboss(typeof currentEmboss !== 'undefined' ? currentEmboss : 'none');
}

function vpQuoteSpec() {
  var cut = vpQuoteCut();
  if (!cut) return null;

  var finish = vpQuoteFinish();
  var emboss = vpQuoteEmboss(cut);

  var dims = vpGetCurrentDims();
  var w = dims && isFinite(Number(dims.w)) ? Number(dims.w) : 2;
  var h = dims && isFinite(Number(dims.h)) ? Number(dims.h) : 2;
  if (w <= 0) w = 2;
  if (h <= 0) h = 2;

  var qtyEl = typeof document !== 'undefined' ? document.getElementById('qtyInput') : null;
  var qty = qtyEl ? parseInt(qtyEl.value, 10) : 0;
  if (!qty || qty < 1) qty = 50;

  var spec = { w: w, h: h, qty: qty, cut: cut, finish: finish, emboss: emboss };
  var laminate = emboss === 'none' ? vpQuoteLaminate() : '';
  if (laminate) spec.laminate = laminate;   // only when charged, so every other spec stays as it was
  return spec;
}

// ── Posters / yard signs / banners ────────────────────────────────────────────
// Posters: Satin up to 24×36; Holo / Spot Holo up to 18×24. Prices are the shop's own Shopify product
// "Custom Poster Printing" (8782525399198), Satin packs, read 2026-10-10 —
// each = pack price ÷ pieces. A bigger order never costs more per poster than a
// smaller one (that product's 60–90 packs run higher per poster than its 50).
// Custom sizes price by area between the two nearest stock sizes.

// Holographic / Spot Holographic: same product's Holo packs (both priced the
// same), up to 18×24 only — Josh 10/10.
var VP_POSTER_HOLO_TABLE = [
  { w: 8.5, h: 11, packs: { 5: 40.5, 10: 60,  20: 118.5, 30: 176, 40: 232,   50: 286.5, 100: 540,  200: 1068 } },
  { w: 11,  h: 14, packs: { 5: 50.5, 10: 75,  20: 148.5, 30: 210, 40: 282.5, 50: 355,   100: 675,  200: 1335 } },
  { w: 11,  h: 17, packs: { 5: 61,   10: 90,  20: 178,   30: 255, 40: 322.5, 50: 390,   100: 810,  200: 1602 } },
  { w: 12,  h: 18, packs: { 5: 71,   10: 105, 20: 207.5, 30: 295, 40: 385,   50: 475,   100: 945,  200: 1869 } },
  { w: 18,  h: 24, packs: { 5: 142,  10: 210, 20: 400,   30: 560, 40: 727.5, 50: 895,   100: 1890, 200: 3738 } }
];
var VP_POSTER_HOLO_MAX = { short: 18, long: 24 };

var VP_PRINT_FINISH = {
  satin:       { id: 'satin',     label: 'Satin' },
  'spot-holo': { id: 'spot-holo', label: 'Spot Holo' },
  holo:        { id: 'holo',      label: 'Holographic' }
};

var VP_POSTER_QTYS = [5, 10, 20, 30, 40, 50, 100, 200];
var VP_POSTER_MAX = { short: 24, long: 36 };
var VP_POSTER_TABLE = [
  { w: 8.5, h: 11, packs: { 5: 13.5, 10: 20,  20: 39.5, 30: 58.5, 40: 77.5,  50: 95.5,  100: 180, 200: 356  } },
  { w: 11,  h: 14, packs: { 5: 17,   10: 25,  20: 49.5, 30: 70,   40: 95,    50: 119.5, 100: 225, 200: 445  } },
  { w: 11,  h: 17, packs: { 5: 20.5, 10: 30,  20: 59.5, 30: 85,   40: 107.5, 50: 130,   100: 270, 200: 534  } },
  { w: 12,  h: 18, packs: { 5: 23.5, 10: 35,  20: 69,   30: 100,  40: 130,   50: 160,   100: 315, 200: 623  } },
  { w: 18,  h: 24, packs: { 5: 44,   10: 65,  20: 125,  30: 175,  40: 227.5, 50: 280,   100: 585, 200: 1157 } },
  { w: 24,  h: 36, packs: { 5: 67.5, 10: 100, 20: 190,  30: 275,  40: 362.5, 50: 450,   100: 900, 200: 1780 } }
];

// Yard signs: 18×24 4mm coroplast, stand included — AA Designs (aadesigns.co)
// list prices read from their pricing API 2026-10-10. AA sells one price for
// the sign; single and double sided share it here.
var VP_YARD_TABLE = [
  { qty: 1, total: 14 }, { qty: 2, total: 27 }, { qty: 5, total: 67 },
  { qty: 10, total: 133 }, { qty: 20, total: 264 }, { qty: 25, total: 329 },
  { qty: 50, total: 644 }, { qty: 100, total: 1237 }, { qty: 500, total: 5421 },
  { qty: 1000, total: 10291 }
];

// Banners: 13oz vinyl, unhemmed, grommets. Max 50" × 120" (Josh to HEADIE,
// 2026-07-08). Rate fits the 2026 single-banner sales (3'×3' $55, 2'×6' $95,
// 50×38 $100, 50×50 $120): $7/sq ft, $40 minimum. Windshield/car strips are
// stickers, not banners — they never set banner prices.
var VP_BANNER = { perSqft: 7, floor: 40, maxShort: 50, maxLong: 120 };

function vpGetPrintKind() {
  if (typeof currentCat === 'undefined' || currentCat !== 'posters') return null;
  var chip = String(typeof currentChipId !== 'undefined' && currentChipId ? currentChipId : '').toLowerCase();
  var cat  = typeof CATEGORIES !== 'undefined' ? CATEGORIES.posters : null;
  var name = String((cat && (cat._customName || cat.name)) || '').toLowerCase();
  if (chip === 'yard-signs' || name.indexOf('yard') !== -1) return 'yard-signs';
  if (chip === 'banners' || name.indexOf('banner') !== -1) return 'banners';
  return 'posters';
}

function vpPrintSizes(kind) {
  if (kind === 'yard-signs') {
    return [{ label: '18" \xd7 24"', w: 18, h: 24, default: true }];
  }
  if (kind === 'banners') {
    return [
      { label: "2' \xd7 2'",  w: 24, h: 24 },
      { label: "2' \xd7 3'",  w: 24, h: 36, default: true },
      { label: "2' \xd7 4'",  w: 24, h: 48 },
      { label: "2' \xd7 6'",  w: 24, h: 72 },
      { label: "2' \xd7 8'",  w: 24, h: 96 },
      { label: "3' \xd7 3'",  w: 36, h: 36 },
      { label: "3' \xd7 6'",  w: 36, h: 72 },
      { label: "3' \xd7 8'",  w: 36, h: 96 },
      { label: "3' \xd7 10'", w: 36, h: 120 },
      { label: "4' \xd7 4'",  w: 48, h: 48 },
      { label: "4' \xd7 6'",  w: 48, h: 72 },
      { label: "4' \xd7 8'",  w: 48, h: 96 },
      { label: "4' \xd7 10'", w: 48, h: 120 },
      { label: 'Custom', w: null, h: null }
    ];
  }
  return [
    { label: '8.5" \xd7 11"', w: 8.5, h: 11 },
    { label: '11" \xd7 14"', w: 11, h: 14 },
    { label: '11" \xd7 17"', w: 11, h: 17 },
    { label: '12" \xd7 18"', w: 12, h: 18 },
    { label: '18" \xd7 24"', w: 18, h: 24, default: true },
    { label: '24" \xd7 36"', w: 24, h: 36 },
    { label: 'Custom', w: null, h: null }
  ];
}

function vpPrintQtyTiers(kind) {
  if (kind === 'banners') return [1, 2, 3, 5, 10];
  if (kind === 'yard-signs') return [1, 2, 5, 10, 20, 25, 50, 100, 500, 1000];
  return VP_POSTER_QTYS.slice();
}

function vpPrintMinQty(kind) {
  return kind === 'posters' ? VP_POSTER_QTYS[0] : 1;
}

// Largest size a custom entry may reach, short side × long side.
function vpPrintMaxDims(kind) {
  if (kind === 'banners') return { short: VP_BANNER.maxShort, long: VP_BANNER.maxLong };
  if (kind === 'posters') return vpPosterIsHolo() ? VP_POSTER_HOLO_MAX : VP_POSTER_MAX;
  return { short: 18, long: 24 };
}

function vpQtyNoun(qty) {
  var kind = vpGetPrintKind();
  var n = parseInt(qty, 10) || 0;
  if (kind === 'posters') return n === 1 ? 'poster' : 'posters';
  if (kind === 'yard-signs') return n === 1 ? 'sign' : 'signs';
  if (kind === 'banners') return n === 1 ? 'banner' : 'banners';
  var u = (typeof CATEGORIES !== 'undefined' && CATEGORIES[currentCat] && CATEGORIES[currentCat].unit) || 'sticker';
  return n === 1 ? u : u + 's';
}

function vpPrintFinishMeta() {
  var id = (typeof currentPrintFinish !== 'undefined' && currentPrintFinish) ? currentPrintFinish : 'satin';
  return VP_PRINT_FINISH[id] || VP_PRINT_FINISH.satin;
}

function vpPosterIsHolo() {
  var id = vpPrintFinishMeta().id;
  return id === 'holo' || id === 'spot-holo';
}

// Does a w×h poster fit the holo size limit?
function vpPosterHoloFits(w, h) {
  return Math.min(w, h) <= VP_POSTER_HOLO_MAX.short && Math.max(w, h) <= VP_POSTER_HOLO_MAX.long;
}

// Per-piece price at the highest listed tier ≤ qty, never above a smaller tier.
function vpTierEach(tiers, qty, eachOf) {
  var best = eachOf(tiers[0]);
  for (var i = 0; i < tiers.length && tiers[i].qty <= qty; i++) {
    best = Math.min(best, eachOf(tiers[i]));
  }
  return best;
}

function vpPosterEach(w, h, qty) {
  var tiers = VP_POSTER_QTYS.map(function(q) { return { qty: q }; });
  var table = vpPosterIsHolo() ? VP_POSTER_HOLO_TABLE : VP_POSTER_TABLE;
  var rows = table.map(function(r) {
    return {
      area: r.w * r.h,
      each: vpTierEach(tiers, qty, function(t) { return r.packs[t.qty] / t.qty; })
    };
  });
  var area = w * h;
  if (area <= rows[0].area) return rows[0].each;
  for (var i = 1; i < rows.length; i++) {
    if (area <= rows[i].area) {
      var a = rows[i - 1], b = rows[i];
      return a.each + (area - a.area) / (b.area - a.area) * (b.each - a.each);
    }
  }
  return rows[rows.length - 1].each;
}

function vpYardEach(qty) {
  return vpTierEach(VP_YARD_TABLE, qty, function(t) { return t.total / t.qty; });
}

function vpBannerEach(w, h, qty) {
  var each = w * h / 144 * VP_BANNER.perSqft;
  if (qty >= 10) each *= 0.88;
  else if (qty >= 5) each *= 0.93;
  else if (qty >= 2) each *= 0.97;
  return Math.max(each, VP_BANNER.floor);
}

function vpComputePrintTotal(kind, w, h, qty) {
  kind = kind || vpGetPrintKind();
  qty = Math.max(vpPrintMinQty(kind), parseInt(qty, 10) || 1);
  w = Number(w); h = Number(h);
  if (!isFinite(w) || w <= 0) w = 18;
  if (!isFinite(h) || h <= 0) h = 24;

  var each;
  if (kind === 'yard-signs') each = vpYardEach(qty);
  else if (kind === 'banners') each = vpBannerEach(w, h, qty);
  else each = vpPosterEach(w, h, qty);
  each = Math.round(each * 100) / 100;
  return { each: each, total: Math.round(each * qty * 100) / 100, qty: qty, w: w, h: h, kind: kind };
}

// ── Top-level entry point ─────────────────────────────────────────────────────

// Returns total price for (productType, w, h, qty), or null → use legacy formula.
function vpComputeTotal(productType, w, h, qty) {
  if (!productType || productType === 'die-cut') return null;
  var eff = Math.sqrt(w * h);
  if (productType === 'kc-transfer') return vpKcTransferTotal(w, h, qty);
  if (productType !== 'sheets' && eff > VP_LARGE_THRESHOLD) return vpLargeLookup(eff, qty);
  return vpSmallLookup(productType, eff, qty);
}

// ─── END PRICING ENGINE v2 ────────────────────────────────────────────────────

/**
 * Returns a session-unique order ref string used as the artwork filename prefix
 * and Drive folder name (e.g. "ORD-2607-a3f9").
 *
 * Format: ORD-YYMM-XXXX
 *   YY   = 2-digit year  (e.g. 26)
 *   MM   = 2-digit month (e.g. 07)
 *   XXXX = 4 random hex chars
 *
 * This is random per session — NOT a sequential counter — so it is safe across
 * multiple simultaneous customers. Collision probability for the same month is
 * 1 in 65,536, negligible for a custom print shop.
 *
 * Note: this ref is for internal tracking / Drive folder naming only. The canonical
 * Shopify order number is assigned by Shopify when the draft order is created.
 *
 * @returns {string}  e.g. "ORD-2607-a3f9"
 */
function getNextOrderRef() {
  var d    = new Date();
  var yy   = String(d.getFullYear()).slice(-2);
  var mm   = String(d.getMonth() + 1).padStart(2, '0');
  var rand = Math.floor(Math.random() * 0xFFFF).toString(16).padStart(4, '0');
  return 'ORD-' + yy + mm + '-' + rand;
}

// seedOrderCounter previously synced a localStorage sequential counter from Shopify.
// No longer needed since order refs are now random-per-session, but kept as a no-op
// stub so any existing call sites don't break.
function seedOrderCounter() { /* no-op — sequential counter replaced by random ref */ }
